import {I18n} from "../I18n";

const playerValidator = lang => {

    return {
        folderValidator: {
            name: {
                rules: [
                    {
                        test: (value) => {
                            return value && value.trim().length > 0;
                        },
                        message: I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY,
                    },
                ],
                errors: [],
                valid: false,
                state: '',
            },
        },
        mediaValidator: {
            folderId: {
                rules: [
                    {
                        test: (value) => {
                            return value && value > 0;
                        },
                        message: I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY,
                    },
                ],
                errors: [],
                valid: false,
                state: '',
            },
            file: {
                rules: [
                    {
                        test: (value) => {
                            return value;
                        },
                        message: I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY,
                    },
                    {
                        test: (value) => {
                            return !value || value.size <= 500000000; //500MB
                        },
                        message: I18n[lang].FILE_SIZE_IS_TOO_LARGE
                            + ". "
                            + I18n[lang].LIMIT
                            + ": 500MB",
                    },
                ],
                errors: [],
                valid: false,
                state: '',
            },
        },
    }
}
export default playerValidator;


// WEBPACK FOOTER //
// ./src/helpers/playerValidator.js